import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Box,
  Button,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Link,
  Td,
  Flex,
  Text,
  Stack,
  Input,
  Select,
} from "@chakra-ui/react";
import { BASE_URL } from "../../../Globalapi/Globalapi";

const ClassTrBusStudents = () => {
  const [busStudents, setBusStudents] = useState([]);
  const [busList, setBusList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedBus, setSelectedBus] = useState("");
  const [sortOption, setSortOption] = useState("name");
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  useEffect(() => {
    const fetchBusStudents = async () => {
      try {
        const response = await axios.post(
          `${BASE_URL}/staff/students/bus_students.php`,
          {
            staff_id: sessionStorage.getItem("staff_id"),
            school_id: sessionStorage.getItem("school_id"),
          }
        );
        console.log("cls_tr", response);

        if (response.data.success) {
          setBusStudents(response.data.data);
        } else {
          setError(response.data.message || "Failed to fetch bus students.");
        }
      } catch (err) {
        setError(
          err.message || "An error occurred while fetching bus students."
        );
      } finally {
        setLoading(false);
      }
    };

    const fetchBusList = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}/admin/bus/vehicle/list_all_bus_details.php`,
          {
            params: { school_id: sessionStorage.getItem("school_id") },
          }
        );
        if (response.data.success) {
          setBusList(response.data.data);
        } else {
          setError(response.data.message || "Failed to fetch bus list.");
        }
      } catch (err) {
        setError(err.message || "An error occurred while fetching bus list.");
      }
    };

    fetchBusStudents();
    fetchBusList();
  }, []);

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleBusFilter = (e) => {
    setSelectedBus(e.target.value);
  };

  const handleSortChange = (e) => {
    setSortOption(e.target.value);
    const sortedStudents = [...busStudents];
    if (e.target.value === "name") {
      sortedStudents.sort((a, b) =>
        a.student_name.localeCompare(b.student_name)
      );
    } else if (e.target.value === "bus_no") {
      sortedStudents.sort((a, b) => a.bus_no - b.bus_no);
    }
    setBusStudents(sortedStudents);
  };

  const filteredStudents = busStudents
    .filter((student) =>
      student.student_name.toLowerCase().includes(searchTerm.toLowerCase())
    )
    .filter((student) => (selectedBus ? student.bus_no === selectedBus : true));

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentData = filteredStudents.slice(indexOfFirstRow, indexOfLastRow);

  const totalPages = Math.ceil(filteredStudents.length / rowsPerPage);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  // if (error) {
  //   return <div>Error: {error}</div>;
  // }

  return (
    <Box maxWidth="100%">
      <div className="teacher-list-container">
        <div
          className="header"
          style={{ display: "flex", alignItems: "center" }}
        >
          <h1 style={{ fontSize: "20px", margin: 0 }}>Student Bus Details</h1>
          <div className="action-buttons" style={{ marginLeft: "auto" }}>
            <div className="export-dropdown">
              <Flex gap={2}>{/* <Fine_Modal /> */}</Flex>
            </div>
          </div>
        </div>

        <Box className="breadcrumb">
          <Link
            to="/admin"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <span>Dashboard</span>
          </Link>{" "}
          / <span>Bus </span> /
          <Link
            to="/class/classlist"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <span>Student-Bus Details</span>
          </Link>
        </Box>
      </div>
      <Box p={6} flex="2" mb={9}>
      <Flex
  direction={{ base: "column", md: "row" }}
  justify="space-between"
  align="center"
  // mb={1}
  p={3}
  className="sb"
  width="100%" // Ensure full width on mobile devices
>
  {/* Left-aligned section */}
  <Flex align="center" width={{ base: "100%", md: "auto" }}> {/* Full width on mobile */}
    <Text mr={2}>Rows Per Page</Text>
    <Select
      width={{base:"220px",md:"120px"}}
      value={rowsPerPage}
      onChange={(e) => setRowsPerPage(Number(e.target.value))}
      borderColor="#E9EDF4"
    >
      <option value={10}>10</option>
      <option value={20}>20</option>
      <option value={50}>50</option>
    </Select>
  </Flex>

  {/* Right-aligned section */}
  <Flex
    align="center"
    justify="flex-end"
    gap={4}
    flexWrap="wrap"
    ml={{ base: 0, md: "auto" }}
    width={{ base: "100%", md: "auto" }}  
  >
    <Input
      placeholder="Search by student name"
      value={searchTerm}
      onChange={handleSearch}
      width={{ base: "100%", md: "auto" }} 

      mt={{base:2,md:0}}
    />
    <Select
      placeholder="Filter by bus"
      value={selectedBus}
      onChange={handleBusFilter}
      width={{ base: "100%", md: "auto" }}  
      borderColor="#E9EDF4"
    >
      {busList.map((bus) => (
        <option key={bus.bus_no} value={bus.bus_no}>
          {bus.bus_no}
        </option>
      ))}
    </Select>
  </Flex>
</Flex>


        <Box overflowX="auto" maxWidth="100%">
          <Table  sx={{
                "tbody tr:nth-of-type(even)": { backgroundColor: "#f2f4f8" },
              }}>
            <Thead>
              <Tr>
                <Th>Student Name</Th>
                <Th>Bus No</Th>
                <Th>Journey Start</Th>
                <Th>Destination</Th>
                <Th>Pickup Location</Th>
                <Th>Drop Location</Th>
                <Th>Driver Name</Th>
                <Th>Conductor Name</Th>
                <Th>Bus Fee</Th>
                <Th>Due Date</Th>
              </Tr>
            </Thead>
            <Tbody>
              {currentData.map((student) => (
                <Tr key={student.id}>
                  <Td>{student.student_name}</Td>
                  <Td>{student.bus_no}</Td>
                  <Td>{student.start_place}</Td>
                  <Td>{student.end_place}</Td>
                  <Td>{student.pickup_location_name}</Td>
                  <Td>{student.drop_location_name}</Td>
                  <Td>{student.driver_name}</Td>
                  <Td>{student.conductor_name}</Td>
                  <Td>{student.bus_fee}</Td>
                  <Td>{student.due_date}</Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </Box>
        <Flex justify="end" p={3} className="sb2">
          <Button
            onClick={() => handlePageChange(currentPage - 1)}
            isDisabled={currentPage === 1}
            mr={2}
          >
            Prev
          </Button>
          <Stack direction="row" spacing={2} mx={2}>
            {Array.from({ length: totalPages }, (_, index) => (
              <Button
                key={index + 1}
                onClick={() => handlePageChange(index + 1)}
                backgroundColor={currentPage === index + 1 ? "teal" : undefined}
                color={currentPage === index + 1 ? "white" : undefined}
              >
                {index + 1}
              </Button>
            ))}
          </Stack>
          <Button
            onClick={() => handlePageChange(currentPage + 1)}
            isDisabled={currentPage === totalPages}
            ml={2}
          >
            Next
          </Button>
        </Flex>
      </Box>
    </Box>
  );
};

export default ClassTrBusStudents;
